import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import { SelectList } from '../../../shared/SelectList';

import './NewCrossBorderReceiverList.scss';

const NewCrossBorderReceiverListSkeleton = (): JSX.Element => (
    <div className="cross-border-payment-receiver-list-skeleton__container">
        <SelectList>
            {Array.from(Array(5)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`cb-receiver-skeleton-${index}`} className="cross-border-payment-receiver-skeleton__list-item">
                    <DarkSkeleton
                        className="cross-border-payment-receiver-skeleton__description"
                        width={200}
                        height={20}
                    />
                </li>
            ))}
        </SelectList>
    </div>
);

export default NewCrossBorderReceiverListSkeleton;
